import { useBaseViewModel } from '@/common';
import { QrCodeEntity } from '@/domain/entities/users';
import { GenerateQRCodeUseCase } from '@/domain/use-cases/users/generateQRCode';
import { useState } from 'react';
import { UsersRepoIml } from '../adapters/repositories';

export const generateQRCode = () => {
  const generateQRCode = new GenerateQRCodeUseCase(new UsersRepoIml());

  const { loading, error, catchAction } = useBaseViewModel();
  const [qrCodeData, setQrCodeData] = useState<QrCodeEntity>({
    success: false,
    message: '',
  });

  const actionGenerateQRCode = () => {
    catchAction(async () => {
      const data = await generateQRCode.run();
      setQrCodeData(data);
    });
  };

  return {
    loading,
    error,
    qrCodeData,
    actionGenerateQRCode,
  };
};
